import { render } from "./CarBurguer.vue?vue&type=template&id=60eaab0a&scoped=true"
import script from "./CarBurguer.vue?vue&type=script&lang=js"
export * from "./CarBurguer.vue?vue&type=script&lang=js"

import "./CarBurguer.vue?vue&type=style&index=0&id=60eaab0a&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60eaab0a"]])

export default __exports__